import { cn } from '@tempo-io/sui-class-utils';

export const DependencyDots = ({ side }: { side: 'left' | 'right' }) => (
  <span
    data-testid={`dependency-dots-${side}`}
    className={cn(
      'pointer-events-none absolute top-0 z-10 flex h-full items-center gap-0.5',
      side === 'left' ? 'right-full pr-0.5' : 'left-full pl-0.5',
    )}
  >
    <span className="size-[3px] rounded-full bg-icon-neutral-secondary" />
    <span className="size-[3px] rounded-full bg-icon-neutral-secondary" />
    <span className="size-[3px] rounded-full bg-icon-neutral-secondary" />
  </span>
);
